/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { EMPLOYEE_CONTRACT_POSITIONS } from 'domain/people/employee/contracts/shared/input/EmployeeContractPositionDropdown';

const ContractPositionField = (props: FieldProps) => {
  return <EnumField {...props} options={EMPLOYEE_CONTRACT_POSITIONS} />;
};

export default ContractPositionField;
